@if (isLoading()) {
<app-spinner data-test-id="app-config-spinner"></app-spinner>
} @else {
<app-card
  [background]="isEditing"
  size="large"
  [fullHeight]="true"
  [spacingBottom]="Spacing.NONE"
  data-test-id="app-config-card"
>
  <div class="app-config-content">
    <section class="config-section">
      <app-heading
        class="main-heading"
        [titleLevel]="3"
        [headingLevel]="1"
        [spacingBottom]="HeadingSpacing.MEDIUM"
        >{{ 'navigation.appConfig' | translate }}</app-heading
      >
      <div class="logo-information">
        <app-heading
          class="section-heading"
          [titleLevel]="2"
          [headingLevel]="2"
          [spacingBottom]="HeadingSpacing.X_SMALL"
          >{{ 'appConfig.logo' | translate }}</app-heading
        >
        <p>
          {{
            'appConfig.imageSize'
              | translate : { width: '1080', height: '166' }
          }}<br />
          {{ 'appConfig.imageFileFormat' | translate }}<br />
          {{ 'appConfig.imageMaxFileSize' | translate : { '0': '1' }
          }}<br /><br />
          {{ 'appConfig.defaultLogoNote' | translate }}
        </p>
      </div>
      <div class="input-and-buttons-container">
        <div class="input-drop large">
          <img
            class="uploaded-image"
            *ngIf="imageUrl"
            [src]="imageUrl"
            alt="Mobile logo missing"
          />
          <input
            #fileInput
            type="file"
            accept="image/png,image/jpeg"
            (change)="onFileSelected($event)"
            [hidden]="true"
            data-test-id="app-config-file-input"
          />
          @if (isLoading()) {
          <app-spinner></app-spinner>
          }
        </div>

        <div class="logo-button-container">
          <app-form-action-button
            type="upload"
            [disabled]="!isEditing"
            (handleClick)="triggerFileInput()"
            data-test-id="app-config-upload-button"
          >
          </app-form-action-button>
          <app-form-action-button
            type="resetToDefault"
            [buttonType]="NativeButtonType.RESET"
            [disabled]="!canResetLogoToDefault()"
            (handleClick)="onClickResetLogo()"
            data-test-id="app-config-reset-logo-button"
          >
          </app-form-action-button>
        </div>
      </div>
    </section>
    <section class="preview-section">
      <app-form-action-button
        [type]="isEditing ? 'save' : 'edit'"
        [buttonType]="NativeButtonType.SUBMIT"
        [disabled]="!isFormValid()"
        (handleClick)="isEditing ? onSave() : onEdit()"
        data-test-id="app-config-save-edit-button"
      >
      </app-form-action-button>
      <span class="preview-info">
        {{ 'appConfig.previewInfo' | translate }}
      </span>
      <div class="mobile-app-preview-container">
        <div class="mobile-app-preview">
          <div
            class="mobile-app-preview-logo-container"
            [ngClass]="{
              'default-logo-container': imageUrl === _defaultLogoUrl
            }"
          >
            <img
              class="mobile-app-preview-logo"
              *ngIf="imageUrl"
              [src]="imageUrl"
              alt="{{ 'common.logo' | translate }}"
            />
          </div>
        </div>
      </div>
    </section>
    <app-confirm-dialog
      [(isOpen)]="isResetLogoDialogOpen"
      [title]="'appConfig.resetLogoDialogTitle' | translate"
      [subTitle]="subTitle"
      [primaryText]="'common.keep' | translate"
      [secondaryText]="'common.reset' | translate"
      (handlePrimaryButton)="isResetLogoDialogOpen.set(false)"
      (handleSecondaryButton)="onConfirmResetLogo()"
      data-test-id="app-config-mobile-logo"
    ></app-confirm-dialog>
  </div>
</app-card>
}

<app-save-changes-confirmation></app-save-changes-confirmation>
